<template>
  <nav class="main_nav_container">
      <router-link tag="div" to="/" class="logo_wrapper">
          <h1 :class="{bc: this.$router.history.current.path !=='/' && this.showNav === false }" class="logo_big">agmar</h1>
          <h3 :class="{bc: this.$router.history.current.path !=='/' && this.showNav === false }" class="logo_small">meble kuchenne.</h3>
      </router-link>
      <button class="hamburger_button" @click="showNav = !showNav">
          <div :class="{close_nav: showNav, bb: this.$router.history.current.path !=='/' && this.showNav === false }" class="ham_item"></div>
          <div :class="{bb: this.$router.history.current.path !=='/' && this.showNav === false }" v-if="!showNav" class="ham_item"></div>
          <div :class="{close_nav: showNav, bb: this.$router.history.current.path !=='/' && this.showNav === false }" class="ham_item"></div>
      </button>
      <transition name="fade">
      <ul class="items_wrapper" v-show="showNav">
          <li class="single_link"><router-link to="/admin" tag="div" @click="showNav = !showNav" class="link">Panel</router-link></li>
          <li class="single_link"><router-link to="/admin/gallery" tag="div" @click="showNav = !showNav" class="link">Galeria</router-link></li>
          <li class="single_link"><router-link to="/admin/offer" tag="div" @click="showNav = !showNav" class="link">Oferta</router-link></li>
          <!-- <li class="single_link"><router-link to="/admin/facebook" tag="div" @click="showNav = !showNav" class="link">Facebook</router-link></li> -->
          <!-- <li class="single_link"><router-link to="/admin/contact" tag="div" @click="showNav = !showNav" class="link">Kontakt</router-link></li> -->
          <!-- <li class="single_link"><router-link to="/admin/texts" tag="div" @click="showNav = !showNav" class="link">Teksty</router-link></li> -->
      </ul>
      </transition>
  </nav>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
export default {
    name: 'adminNav',
    data(){
        return{
            showNav: false
        }
    },
    computed:{
        ...mapState({
            logged: state=>state.login.user.loggedIn
        })
    },
    methods:{
        ...mapMutations(['signOut'])
    }
}
</script>

<style lang="scss">
.bc{
  color: black !important;
}
.bb{
  background: black !important;
}
.main_nav_container{
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 11;
    padding: 34px;
}
.items_wrapper{
    list-style: none;
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background: rgb(7, 88, 88);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: 10;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.logo_wrapper{
    z-index: 13;
    cursor: pointer;
}
.logo_big{
    text-transform: uppercase;
    color: white;
    font-size: 24px;
}
.logo_small{
    color: white;
    font-size: 12px;
}
.hamburger_button{
    background: none;
    border: none;
    z-index: 13;
    &:focus{
        outline: none;
    }
}
.ham_item{
    width: 40px;
    height: 4px;
    background: white;
    margin: 4px 0;
    transition: 0.1s;
}
.link{
    color: white;
    font-size: 40px;
    text-transform: uppercase;
}
.close_nav:nth-child(1){
    transform: rotate(45deg) translate(5px);
}
.close_nav:nth-child(2){
    transform: rotate(-45deg) translate(5px);
}
@media (min-width:1440px){
   .main_nav_container{
        padding: 32px 100px;
        margin: 10px 0;
   }
   .logo_big{
       font-size: 32px;
   }
   .logo_small{
       font-size: 16px;
   }
   .logo_big, .logo_small{
       color: black;
   }
    .hamburger_button{
        display: none;
   }
    .items_wrapper{
        display: flex !important;
        position: relative;
        height: auto;
        width: auto;
        flex-direction: row;
        background: none;
        .single_link{
            margin: 0 24px;
            &:last-child{
                margin-right: 0;
            }
        }
        .link{
            color: black;
            font-size: 15px;
            cursor: pointer;
        }
    }
}
.signOut{
  background: black;
  color: white;
  width: 100px;
  border: none;
  height: 30px;
  position: absolute;
  bottom: 50px;
}

</style>